import React, { Component } from 'react';
import { connect } from 'react-redux';

import getVisibleCategories from 'selectors/possessions/getVisibleCategories';
import scrollToComponent from 'utils/scrollToComponent';

import InventoryGroup from '../InventoryGroup';
import InventoryComponent from './InventoryComponent';
import { ICategory } from 'types/possessions';
import { IAppState } from 'types/app';

interface State {
  activeItem?: number,
}

export class InventoryContainer extends Component<Props, State> {
  static displayName = 'InventoryContainer';

  state = {
    activeItem: undefined,
  };

  handleScrollToCategory = ({ id, name }: { id: number, name : string}) => {
    const { dispatch } = this.props;
    const el = document.querySelector(`[data-group-name="${name}"]`);
    if (el) {
      this.setState({ activeItem: id });
      scrollToComponent(
        el,
        { offset: 0, align: 'top' },
        dispatch,
      );
    }
  };

  handleEnterWaypoint = (id: number) => {
    const { scrolling } = this.props;
    if (scrolling) {
      return;
    }
    this.setState({ activeItem: id });
  };

  renderInventoryGroups = () => {
    const { categories, filterString } = this.props;
    return categories.map(({ name, qualities }, i) => (
      <InventoryGroup
        id={i}
        key={name}
        filterString={filterString}
        name={name}
        onEnter={this.handleEnterWaypoint}
        qualities={qualities}
      />
    ));
  };

  render = () => {
    const { categories, onFilter, filterString } = this.props;
    const { activeItem } = this.state;

    return (
      <InventoryComponent
        activeItem={activeItem}
        categories={categories}
        filterString={filterString}
        onFilter={onFilter}
        onScrollToCategory={this.handleScrollToCategory}
      >
        {this.renderInventoryGroups()}
      </InventoryComponent>
    );
  }
}

interface Props {
  categories: ICategory[],
  dispatch: Function,
  filterString: string,
  onFilter: (_: any) => void,
  scrolling: boolean,
}

const mapStateToProps = (state: IAppState, props: Props) => ({
  categories: getVisibleCategories(state, props),
  scrolling: state.scrollToComponent.scrolling,
});

export default connect(mapStateToProps)(InventoryContainer);